import { StyleSheet, Platform, ViewStyle, Dimensions } from "react-native";
import screens from "../../../theme/screens";

export function isBigScreen() {
  return Dimensions.get("window").width > screens.sm;
}

export const styles = StyleSheet.create({
  stickyHeader: {
    ...Platform.select({
      web: {
        zIndex: 10,
        backgroundColor: "white",
        position: "sticky" as const,
        top: 0,
      } as unknown as ViewStyle,
    }),
  },
});
